import { makeStyles } from '@mui/styles';

const useBadgeStyles = makeStyles((theme: any) => {
  const baseBadgeStyle = {
    backgroundColor: theme.palette.primary.main,
    marginLeft: '5px',
    marginBottom: '5px',
    borderRadius: '4px',
    color: theme.palette.mode === 'dark' ? 'rgba(0, 0, 0, 0.87)' : 'white',
    fontFamily: 'Lato',
    fontWeight: '700',
    fontSize: 14,
  };

  return {
    badgeProposal: {
      ...baseBadgeStyle,
      padding: '3px 6.5px',
    },
    badgeMatching: {
      ...baseBadgeStyle,
      padding: '3px 5px',
    },
  };
});

export const simplifiedProposalTableStyles = {
  tableHeaderCell: {
    display: 'inline-block',
    fontSize: 18,
  },
  cellNameWrapper: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
  entityName: {
    marginX: 0.4,
    fontSize: 14,
  },
  entity: {
    fontSize: 16,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  actions: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
  },
  actionRequired: {
    color: '#FA5D00',
  },
  actionOptional: {
    color: '#E6A817',
  },
  actionNotRequired: {
    color: '#047C40',
  },
  actionIndicatorWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
  },
  tableHeaderDateCell: {
    fontSize: 14,
    fontWeight: 500,
  },
  dialogContent: {
    padding: 0,
  },
  warning: {
    padding: 2,
    fontSize: 18,
  },
  table: {
    minWidth: 650,
  },
  controlsWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'end',
    flexDirection: 'row',
  },
  warningDataGrid: {
    width: '70%',
  },
  link: {
    display: 'block',
    cursor: 'pointer',
    margin: 'auto 0',
  },
  logTableHeader: {
    // backgroundColor: '#fafafa',
  },
  logTableNoChangesBox: {
    display: 'flex',
    justifyContent: 'center',
    paddingY: 3,
  },
};

export { useBadgeStyles };
